import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography, useTheme } from '@mui/material'
import { EventType } from '@/features/events/shared/types'
import { ToolHeader } from '../shared'

interface McpToolContextRendererProps {
  readonly toolName: string
  readonly query?: string | undefined
}

export const McpToolContextRenderer: FC<McpToolContextRendererProps> = ({ toolName, query }) => {
  const theme = useTheme()

  return (
    <>
      <ToolHeader eventType={EventType.TOOL_PERMISSION_REQUEST} toolName={toolName} />

      {query && (
        <Box sx={queryContainerSx}>
          <Typography variant="body2" sx={queryValueSx(theme)}>
            &quot;{query}&quot;
          </Typography>
        </Box>
      )}
    </>
  )
}

const queryContainerSx: SxProps<Theme> = {
  mt: 1,
}

const queryValueSx = (theme: Theme): SxProps<Theme> => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
  fontSize: 'inherit',
})
